import { GridColDef } from "@mui/x-data-grid";
import PartNumberCell from "../../componentes/fluxo-engenheiro/Requests/columns/partNumberCell";
import { ResponsibilityGroupStatus } from "../../types/gruposResponsabilidade";

const STATUS_LABEL: Record<ResponsibilityGroupStatus, string> = {
  ACTIVE: "Ativo",
  PENDING_CONFIGURATION: "Aguardando Configurações",
};

export const buildGruposResponsabilidadeColumns = ({
  renderActions,
}: {
  renderActions: (row: any) => React.ReactNode;
}): GridColDef[] => [
  {
    field: "name",
    headerClassName: "header-table",
    renderHeader: () => <b className="partNumberColluns">Grupo</b>,
    renderCell: (params) => <PartNumberCell value={params.value as string} />,
    flex: 1.2,
  },
  {
    field: "administrator",
    headerClassName: "header-table",
    renderHeader: () => (
      <b className="partNumberColluns">Administrador de Engenharia</b>
    ),
    renderCell: (params) => (
      <PartNumberCell value={params.value?.name ?? ""} />
    ),
    flex: 1.4,
  },
  {
    field: "participantsCount",
    headerClassName: "header-table",
    renderHeader: () => <b className="title-table">Participantes</b>,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const participantsCount = params.value as number;

      return (
        <span className="participants-badge">
          {participantsCount} {participantsCount === 1 ? "usuário" : "usuários"}
        </span>
      );
    },
    flex: 0.7,
  },
  {
    field: "status",
    headerClassName: "header-table",
    renderHeader: () => <b className="title-table">Status</b>,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const status = params.value as ResponsibilityGroupStatus;
      return (
        <span className={`status-pill status-pill-${status.toLowerCase()}`}>
          {STATUS_LABEL[status] ?? status}
        </span>
      );
    },
    flex: 1,
  },
  {
    field: "acoes",
    headerClassName: "header-table",
    renderHeader: () => <b className="title-table">Ações</b>,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => renderActions(params.row),
    flex: 1,
  },
];
